export function formatDashboardNumber(value: number, maximumFractionDigits = 0): string {
  return Number(value || 0).toLocaleString('ru-RU', {
    maximumFractionDigits,
  });
}

export function formatDashboardCompact(value: number): string {
  const numericValue = Number(value || 0);
  const absoluteValue = Math.abs(numericValue);
  const units = [
    { threshold: 1_000_000_000, divisor: 1_000_000_000, suffix: ' млрд' },
    { threshold: 1_000_000, divisor: 1_000_000, suffix: ' млн' },
    { threshold: 1_000, divisor: 1_000, suffix: ' тыс.' },
  ];
  const unit = units.find(({ threshold }) => absoluteValue >= threshold);
  if (!unit) return formatDashboardNumber(numericValue, 2);

  return `${(numericValue / unit.divisor).toLocaleString('ru-RU', {
    maximumFractionDigits: absoluteValue >= unit.threshold * 100 ? 0 : 1,
  })}${unit.suffix}`;
}

/** Ось Y для сумм VND: 10 000 000 → «10 млн». */
export function formatDashboardMillions(value: number): string {
  const numericValue = Number(value || 0);
  if (numericValue === 0) return '0';
  const millions = numericValue / 1_000_000;
  const abs = Math.abs(millions);
  return `${millions.toLocaleString('ru-RU', {
    maximumFractionDigits: abs >= 10 || Number.isInteger(millions) ? 0 : 1,
  })} млн`;
}

export function formatDashboardUsdt(value: number): string {
  return Number(value || 0).toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });
}

export function formatDashboardPercent(value: number): string {
  return `${Number(value || 0).toLocaleString('ru-RU', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  })}%`;
}

export function formatDashboardDuration(seconds: number): string {
  const safeSeconds = Math.max(0, Math.round(Number(seconds) || 0));
  return `${safeSeconds.toLocaleString('ru-RU')} сек`;
}
